import React, { useEffect, useState } from "react"
import { clBasic } from "./general";

export default function HorasProyecto({ nombre, horas, horasSemana, color, indHoy }) {

    const [widthSemana, setWidthSemana] = useState("20px")
    useEffect(() => {
        setWidthSemana((document.getElementById("HPhoras").offsetWidth / horas.length).toString() + "px")
    }, [horas.length])

    return (
        <div style={ShorasProyecto} id="HPhoras">
            <div style={Snombre}>
                {nombre}
            </div>
            <div style={{ position: "relative" }}>
                <div style={Splan}></div>
                <div style={Shoras} >
                    {horas.map((h, ind) => (
                        <div style={{ background: h ? color : "", height: (Math.min(h * 4 / horasSemana, 4)).toString() + "vh", width: widthSemana, opacity: (indHoy === -2 || ind < indHoy) ? 0.9 : 0.7, borderBottom: (h > horasSemana) ? "solid 2px red" : "" }} key={ind}
                            onMouseOver={(e) => (e.currentTarget.style.color = "black")}
                            onMouseLeave={(e) => (e.currentTarget.style.color = "transparent")}>
                            {h}
                        </div>)
                    )}
                </div>

            </div>

        </div>
    )
}

const ShorasProyecto = {
    position: "relative",
}

const Snombre = {
    position: "relative",
    color: clBasic,
    fontSize: "2vh",
    fontWeight: 700,
    height: "2.2vh",
    marginBottom: "7px",
    marginLeft: "15px"
}

const Shoras = {
    display: "flex",
    flexDirection: "row",
    color: "transparent",
    fontSize: "1.8vh",
    fontWeight: 500,
    height: "4vh"
}

const Splan = {
    position: "absolute",
    border: "1px solid #e6e6e6",
    width: "100%",
    height: "4vh",
}